var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Guyana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M24,4c-5.391,0-10.275,2.143-13.872,5.612l33.635,11.466C42.346,11.421,34.051,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M43.763,26.922L10.128,38.388C13.725,41.857,18.609,44,24,44C34.051,44,42.346,36.579,43.763,26.922 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.995,24.095L8.274,36.33c0.572,0.728,1.189,1.416,1.854,2.058l33.635-11.466 C43.899,25.996,43.991,25.057,43.995,24.095z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.763,21.078L10.128,9.612c-0.663,0.639-1.278,1.324-1.847,2.048l35.712,12.203 C43.987,22.915,43.897,21.99,43.763,21.078z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M44,24c0-0.046-0.007-0.091-0.007-0.137L8.281,11.66c-0.393,0.5-0.763,1.019-1.107,1.556L22.979,24 L7.174,34.784c0.343,0.534,0.71,1.049,1.1,1.546l35.721-12.235C43.995,24.063,44,24.032,44,24z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M7.174,13.216c-0.483,0.752-0.912,1.54-1.292,2.356L18.245,24L5.882,32.428 c0.38,0.816,0.809,1.604,1.292,2.356L22.979,24L7.174,13.216z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M5.882,15.572C4.687,18.136,4,20.985,4,24s0.687,5.864,1.882,8.428L18.245,24L5.882,15.572z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Guyana);
export default __webpack_public_path__ + "static/media/icons8-guyana.c36f5ecda9b95ed9e3b46f145e0d5d59.svg";
export { ForwardRef as ReactComponent };